module.exports = __webpack_public_path__ + "a6dea20a173b91dc8fda427d89a101d0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-56@2x.png
// module id = 525
// module chunks = 0